import { useMediaQuery } from 'react-responsive';

const useIsMobile = (width = '650px') => {
    const isMobile = useMediaQuery({ query: `(max-width: ${width})` });
    return isMobile;
}

export default useIsMobile